module.exports = __webpack_public_path__ + "img/Flag_of_Guernsey.40b76937.svg";